import { MessageOwner, MessageStatus } from 'types';

// Helper function to update a message in the thread
export const updateMessageInThread = (message, action) => {
  // For file type messages
  if (message.type === 'file') {
    return {
      ...message,
      message: {
        blobFiles: message.message.blobFiles,
        files: action.payload.files,
        utterance: action.payload.utterance || '',
      },
      sequence_id: action.payload.sequence_id,
      status:
        action.payload.status === MessageStatus.ERROR
          ? MessageStatus.ERROR
          : MessageStatus.SENT,
    };
  }

  // For non-file type messages
  return {
    ...message,
    message: message.message || message.utterance || action.payload.utterance,
    sequence_id: action.payload.sequence_id,
    status:
      action.payload.status === MessageStatus.ERROR
        ? MessageStatus.ERROR
        : MessageStatus.SENT,
  };
};

export const isTargetMessage = (message, action) => {
  return message.client_message_id === action.payload.client_message_id;
};

export const isDeliveredMessage = (thread, responseData) => {
  return thread.find(msg => {
    if (msg?.client_message_id) {
      return msg.client_message_id === responseData.client_message_id;
    } else if (msg?.sequence_id) {
      return msg.sequence_id === responseData.sequence_id;
    }
    return null;
  });
};

export const isProactiveMessage = (sequence_id: number, source: MessageOwner) =>
  sequence_id === 1 && source === MessageOwner.USER;

export const isMetaMessage = dialog_response =>
  dialog_response?.ui_component?.type === 'META_DATA';

export const getMessage = (
  source: MessageOwner,
  dialog_response: any,
  utterance: string,
) => {
  return source === MessageOwner.BOT
    ? dialog_response?.prompt?.content || dialog_response?.ui_component
    : utterance;
};

export const getStatus = (source: MessageOwner, client_message_id: string) => {
  return source === MessageOwner.USER && client_message_id
    ? MessageStatus.SENT
    : MessageStatus.PENDING;
};

// The server can signal a sensitive prompt in several documented locations.
// Treat the input as sensitive if the flag is set in any of them.
export const resolveSensitiveInput = (data: any): boolean =>
  Boolean(
    data?.sensitive_input ||
      data?.metadata?.sensitive_input ||
      data?.dialog_response?.prompt?.metadata?.sensitive_input ||
      data?.dialog_response?.prompt?.sensitive_input,
  );
